export default "__VITE_ASSET__CDBT1PZy__"